var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRenewalIcon = function SvgRenewalIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 121,
    viewBox: "0 0 118 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.1318 94.0874C51.3818 98.5874 34.3818 88.3374 28.8818 71.3374L40.1318 68.3374L18.6318 54.0874L7.38184 77.0874L18.3818 74.0874C25.3818 97.0874 48.3818 111.087 70.6318 105.087C80.8818 102.337 89.3818 95.8374 94.8818 87.3374L85.8818 81.0874C82.1318 87.0874 75.8818 92.0874 68.1318 94.0874Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.632 46.5886C95.6318 23.5886 72.6318 9.58861 50.1318 15.5886C39.8818 18.3386 31.3818 24.8386 25.8818 33.3386L34.8818 39.5886C38.8818 33.3386 45.1318 28.3386 52.8818 26.3386C69.6318 21.8386 86.6318 32.0886 92.1318 49.0886L90.1318 49.5886L80.8818 52.0886L102.382 66.3386L113.632 43.3386L102.632 46.5886Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8726 45.2404L45.2422 51.8398L51.8416 76.4703L76.472 69.8709L69.8726 45.2404Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRenewalIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "renewal-icon.61b2b3f151993da4c7884a9372da86b1.svg";